import React, { useState } from 'react';
import { useTeam } from '../pages/crm/useCrm';

// Share / Transfer box used on pipeline records and transactions (contacts have their own on the Contacts page).
//   owner: uid of the current owner; sharedWith: { uid: true }; canManage: owner or admin
//   onShare({ add, remove }), onTransfer(toUid, keepPrevious)
// Share = it also shows in their lists, both can see and work it. Transfer = it moves to them and leaves the
// previous owner's lists (unless "keep ... on it" is ticked).
export default function AccessPanel({ owner, sharedWith = {}, canManage, onShare, onTransfer, meUid, what = 'record' }) {
  const team = useTeam();
  const [shareTo, setShareTo] = useState('');
  const [to, setTo] = useState('');
  const [keep, setKeep] = useState(false);
  const [msg, setMsg] = useState('');
  const nameOf = (u) => (u === meUid ? 'You' : team.find((t) => t.uid === u)?.name || 'Unknown user');
  const shared = Object.keys(sharedWith || {}).filter((u) => sharedWith[u]);
  const box = { border: '1px solid #e5e5e5', borderRadius: 8, padding: 12, margin: '12px 0', background: '#fff', fontSize: 14 };
  const sel = { padding: 6, borderRadius: 6, border: '1px solid #ccc', marginRight: 6 };
  const btn = { padding: '6px 12px', borderRadius: 6, border: '1px solid #B8860B', background: '#D4AF37', color: '#000', cursor: 'pointer', marginRight: 6 };
  const run = async (fn, ok) => { setMsg(''); try { await fn(); setMsg(ok); } catch (e) { setMsg(e.message || 'Could not save'); } };
  return (
    <div style={box}>
      <div><strong>Owner:</strong> {nameOf(owner)}{shared.length ? <> · <strong>Shared with:</strong> {shared.map((u) => (
        <span key={u} style={{ marginRight: 6 }}>{nameOf(u)}{canManage && <button aria-label={`Stop sharing with ${nameOf(u)}`} style={{ border: 0, background: 'none', cursor: 'pointer' }} onClick={() => run(() => onShare({ add: [], remove: [u] }), 'Stopped sharing.')}>×</button>}</span>
      ))}</> : ' · Private'}</div>
      {canManage && (
        <>
          <div style={{ marginTop: 8 }}>
            <select style={sel} value={shareTo} onChange={(e) => setShareTo(e.target.value)} aria-label="Share with">
              <option value="">Share with…</option>
              {team.filter((t) => t.uid !== owner && !shared.includes(t.uid)).map((t) => <option key={t.uid} value={t.uid}>{t.name}</option>)}
            </select>
            <button style={btn} disabled={!shareTo} onClick={() => run(() => onShare({ add: [shareTo], remove: [] }).then(() => setShareTo('')), `Shared. It now shows in their list too.`)}>Share</button>
          </div>
          <div style={{ marginTop: 8 }}>
            <select style={sel} value={to} onChange={(e) => setTo(e.target.value)} aria-label="Transfer to">
              <option value="">Transfer to…</option>
              {team.filter((t) => t.uid !== owner).map((t) => <option key={t.uid} value={t.uid}>{t.name}</option>)}
            </select>
            <label style={{ marginRight: 8 }}><input type="checkbox" checked={keep} onChange={(e) => setKeep(e.target.checked)} /> Keep {owner === meUid ? 'me' : nameOf(owner)} on it (shared)</label>
            <button style={btn} disabled={!to} onClick={() => {
              if (!keep && owner === meUid && !window.confirm(`Transfer this ${what} to ${nameOf(to)}? It will leave your lists and you will no longer see it.`)) return;
              run(() => onTransfer(to, keep), `Transferred to ${nameOf(to)}.`);
            }}>Transfer</button>
          </div>
        </>
      )}
      {msg && <div style={{ marginTop: 6, color: '#555' }}>{msg}</div>}
    </div>
  );
}
